import { I18n } from "i18n-js";

import trDe from "../locales/de.json";
import trEn from "../locales/en.json";
import trFi from "../locales/fi.json";
import trFr from "../locales/fr.json";
import trSv from "../locales/sv.json";

const i18n = new I18n();

i18n.store(trDe);
i18n.store(trEn);
i18n.store(trFi);
i18n.store(trFr);
i18n.store(trSv);

// i18n-js uses the default locale only as the fallback locale. "en" is the safe choice for this.
i18n.defaultLocale = "en";
i18n.enableFallback = true;

// Set the locale to the locale selected by the server - this takes server's choice for default locale into account.
i18n.locale = window.pupilfirst.locale;
i18n.missingTranslationPrefix = "Missing translation: ";

export default i18n;
